import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { useTailoredResumeEdit } from 'builder/components/AutoTailoring/OverviewModal/hooks/useTailoredResumeEdit'

export const FinnishTailoringButton = () => {
  const { i18n } = useI18n()
  const { getJobTrackingPath } = useTailoredResumeEdit()
  const navigate = useNavigate()

  const handleFinishTailoring = useCallback(() => {
    navigate(getJobTrackingPath())
  }, [getJobTrackingPath, navigate])

  return (
    <ButtonV2 onClick={handleFinishTailoring} data-testid="finish-tailoring-button">
      {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.finish_tailoring`)}
    </ButtonV2>
  )
}
